import React, { useEffect } from 'react';

import { createPortal } from 'react-dom';

import { useLoggerOverlay } from './loggerOverlay.hook';
import { Styled } from './loggerOverlay.styles';

export const LoggerOverlay: React.FC = () => {
	const { isOverlayVisible, data, hideOverlay } = useLoggerOverlay();

	useEffect(() => {
		isOverlayVisible && document.addEventListener('keydown', handleKeydownEventListener, false);

		return () => {
			document.removeEventListener('keydown', handleKeydownEventListener, false);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isOverlayVisible]);

	const handleKeydownEventListener = (event: KeyboardEvent) => {
		if (event.key === 'Escape') {
			hideOverlay();
		}
	};

	if (!isOverlayVisible) {
		return null;
	}

	const { data: jsonData, ...rest } = data || {};

	return createPortal(
		<Styled.Container>
			<Styled.CloseButtonContainer>
				<Styled.CloseButton onClick={hideOverlay}>x</Styled.CloseButton>
				<span>(or ESC)</span>
			</Styled.CloseButtonContainer>

			<p style={{ fontSize: '22px', fontWeight: 700, marginBottom: '16px' }}>Logger debugger:</p>

			<p>
				<b>date:</b> {new Date(Date.now()).toLocaleString()}
			</p>

			{Object.entries(rest).map(([key, value]) => {
				return (
					<p key={key} style={{ margin: 0, overflow: 'auto' }}>
						<b>{`${key}: `}</b>
						{`${value}`}
					</p>
				);
			})}

			{jsonData && (
				<>
					<p style={{ margin: 0 }}>
						<b>debugData:</b>
					</p>
					<pre style={{ margin: 0, overflow: 'auto' }}>{JSON.stringify(jsonData, undefined, 2)}</pre>
				</>
			)}
		</Styled.Container>,
		document.body
	);
};
